module.exports = __webpack_public_path__ + "fa991d8b3c314345f445f7183ce069be.MP3";